const campaignDefinitions = [
  {
    id: 'care_landing_download',
    label: 'Vetlyx Care — download-page QR',
    product: 'care',
    placement: 'landing_page',
    filename: 'care-landing-download',
    landingPath: '/care-download/',
    googlePlayPackage: 'com.vetlyx.care',
    appleCampaignEnv: 'VITE_APPLE_CAMPAIGN_CARE_LANDING_DOWNLOAD'
  },
  {
    id: 'pro_landing_download',
    label: 'Vetlyx Pro — download-page QR',
    product: 'pro',
    placement: 'landing_page',
    filename: 'pro-landing-download',
    landingPath: '/pro-download/',
    googlePlayPackage: 'com.vetlyx.app',
    appleCampaignEnv: 'VITE_APPLE_CAMPAIGN_PRO_LANDING_DOWNLOAD'
  },
  {
    id: 'care_practice_print',
    label: 'Vetlyx Care — veterinary practice printed materials',
    product: 'care',
    placement: 'veterinary_practice_print',
    filename: 'care-veterinary-practice-print',
    landingPath: '/care-download/',
    googlePlayPackage: 'com.vetlyx.care',
    appleCampaignEnv: 'VITE_APPLE_CAMPAIGN_CARE_PRACTICE_PRINT'
  }
];

export const QR_CAMPAIGNS = Object.freeze(Object.fromEntries(
  campaignDefinitions.map((definition) => {
    const campaign = Object.freeze({
      ...definition,
      targetUrl: `https://vetlyx.com${definition.landingPath}?qr=${definition.id}`
    });
    return [campaign.id, campaign];
  })
));

export function getQrCampaign(id) {
  if (typeof id !== 'string') return null;
  return QR_CAMPAIGNS[id] || null;
}

export function buildGooglePlayCampaignUrl(campaign) {
  if (!campaign?.googlePlayPackage || !getQrCampaign(campaign.id)) return null;

  const referrer = new URLSearchParams({
    utm_source: 'vetlyx',
    utm_medium: 'qr',
    utm_campaign: campaign.id
  });
  const url = new URL('https://play.google.com/store/apps/details');
  url.searchParams.set('id', campaign.googlePlayPackage);
  url.searchParams.set('referrer', referrer.toString());
  return url.toString();
}

function validAppleCampaignUrl(value) {
  if (!value) return null;
  try {
    const url = new URL(value);
    return url.protocol === 'https:' && url.hostname === 'apps.apple.com' ? url.toString() : null;
  } catch {
    return null;
  }
}

export function resolveCampaignStoreUrl({
  campaign,
  store,
  fallbackUrl,
  appleCampaignUrls = {}
}) {
  if (!campaign) return fallbackUrl;
  if (store === 'google_play') {
    return buildGooglePlayCampaignUrl(campaign) || fallbackUrl;
  }
  if (store === 'app_store') {
    return validAppleCampaignUrl(appleCampaignUrls[campaign.id]) || fallbackUrl;
  }
  return fallbackUrl;
}
